·<template>
  <div class="assets">
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang38') }}</span>
    </div>
    <div class="total_box">
      <div>{{ $t('lang328') }}</div>
      <div class="total f-sb">
        <!-- <div>{{ total }}</div> -->
        <countTo :startVal="total" :endVal="endVal" :duration="2000" :decimals="6"></countTo>
        <van-button class="get_btn" type="primary" @click="collectPledge">{{ $t('lang329') }}</van-button>
      </div>
    </div>

    <div class="">
      <div class="pd1 goods_box" v-if="nft_list.length > 0">
        <div class="goods_list" v-for="(item, index) in nft_list" :key="index">
          <div class="f-sb">
            <span class="title">{{ item.title }}</span>
            <span class="status">{{ $t('lang222') }}</span>
          </div>

          <div class="f-r box">
            <div class="f-col item" v-for="(item1, index1) in JSON.parse(item.details)" :key="index1">
              <van-image class="goods_list_img" radius="10" :src="item1.thum" />
              <div class="right">
                <div style="font-size: 13px">{{ item1.order_no.substring(0, 4) + '****' + item1.order_no.substring(item1.order_no.length - 5, item1.order_no.length) }}</div>
              </div>
            </div>
            <div class="plus f-r" v-if="item.type_id == 1 && JSON.parse(item.details).length < 3" @click="showAddStoring(item)">
              <svg t="1749447443783" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="27760" width="50" height="50">
                <path
                  d="M544.83 557.536l374.19 0.973c17.694 0.046 32.039-14.21 32.085-31.904 0.045-17.74-14.21-32.04-31.904-32.086l-374.258-0.995 0.566-372.561c0.022-17.627-14.256-31.995-31.95-32.041-17.672-0.022-32.018 14.278-32.064 31.973l-0.564 372.47-373.986-0.996c-17.695-0.045-32.04 14.21-32.086 31.904-0.022 8.849 3.552 16.903 9.368 22.719 5.769 5.77 13.734 9.345 22.537 9.367l374.076 0.996-0.565 375.955c-0.023 8.846 3.553 16.856 9.368 22.671 5.793 5.793 13.78 9.346 22.583 9.369 17.672 0.022 31.995-14.256 32.04-31.95L544.83 557.536 544.83 557.536z"
                  fill="#29b286"
                  p-id="27761"
                ></path>
              </svg>
            </div>
          </div>

          <div class="btn_box f-sb-n">
            <div>
              <div class="count f-r" v-if="item.end_time * 1000 - new Date().getTime() <= 604800000">
                <van-count-down
                  class="count"
                  :time="item.end_time * 1000 - new Date().getTime()"
                  :format="`DD${$t('lang9')}HH${$t('lang10')}mm${$t('lang11')}ss${$t('lang12')}`"
                  v-if="item.end_time * 1000 - new Date().getTime() > 0"
                ></van-count-down>
                <span class="count end" v-else>{{ $t('lang475') }}</span>
                <div class="rnew" v-if="item.is_renew == 1" @click="showPayTypeFn(item)">{{ $t('lang472') }} <van-icon name="arrow" color="#29b286" /></div>
              </div>
            </div>
            <!-- 按钮 -->
            <div class="buy" @click="showChoose(item)" v-if="item.type_id == 1">
              <van-button class="buy_btn btn1" type="primary">{{ $t('lang322') }}</van-button>
            </div>
            <div class="buy" @click="removePledge(item)" v-else-if="item.type_id == 2">
              <van-button class="buy_btn btn1" type="primary">{{ $t('lang322') }}</van-button>
            </div>
          </div>
        </div>
      </div>
      <div class="bare" v-if="nft_list.length <= 0">
        <span>{{ $t('lang82') }}</span>
      </div>
    </div>
    <van-popup v-model="showOrders" round closeable>
      <div class="orderpopup">
        <div class="orderpopup_title">{{ $t('lang473') }}</div>
        <van-checkbox-group v-model="checkbox" class="orderpopup_list" v-if="JSON.parse(detail.details).length > 0">
          <div v-for="(item, index) in JSON.parse(detail.details)" :key="index" class="orderpopup_item f-sb">
            <span :class="[checkbox.indexOf(item.order_no) >= 0 ? 'radio-active' : '']">
              {{ item.order_no }}
            </span>
            <van-checkbox :name="item.id" icon-size="18px" checked-color="#21926f"></van-checkbox>
          </div>
        </van-checkbox-group>
        <div class="nodata" v-else>
          <span>{{ $t('lang60') }} </span>
        </div>
        <van-button type="default" class="btn" @click="removePledge(detail)">{{ $t('lang474') }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showAddOrders" round closeable>
      <div class="orderpopup">
        <div class="orderpopup_title">{{ $t('lang334') }}</div>
        <van-checkbox-group v-model="addCheckbox" class="orderpopup_list" v-if="orderlist.length > 0">
          <div v-for="(item, index) in orderlist" :key="index" class="orderpopup_item f-sb">
            <span :class="[checkbox.indexOf(item.order_no) >= 0 ? 'radio-active' : '']">
              {{ item.order_no }}
            </span>
            <van-checkbox :name="item.id" icon-size="18px" checked-color="#21926f"></van-checkbox>
          </div>
        </van-checkbox-group>
        <div class="nodata" v-else>
          <span>{{ $t('lang60') }} </span>
        </div>
        <van-button type="default" class="btn" @click="addPledgeProduct">{{ $t('lang111') }}</van-button>
      </div>
    </van-popup>
    <van-popup v-model="showPayType" round closeable>
      <div class="orderpopup">
        <div class="orderpopup_title">{{ $t('lang470') }}</div>
        <van-radio-group v-model="pay_type" icon-size="17px" checked-color="#21926f" class="f-c payRadio-box">
          <div class="payRadio f-sb" v-if="detail.token && Number(detail.token) > 0">
            <span> {{ $t('lang174') }}：{{ detail.token }} </span>
            <van-radio name="1"></van-radio>
          </div>
          <div class="payRadio f-sb" v-if="detail.teac && Number(detail.teac) > 0">
            <span>TeaC：{{ detail.teac }}</span>
            <van-radio name="2"></van-radio>
          </div>
        </van-radio-group>
        <van-button type="default" class="btn" @click="setRenew">{{ $t('lang111') }}</van-button>
      </div>
    </van-popup>
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" class="loading" color="#29b286" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { homeApi } from '@/api/index';
import { Dialog, Notify, Toast } from 'vant';
import countTo from 'vue-count-to';
export default {
  components: { countTo },
  data() {
    return {
      loading: false,
      total: 0,
      endVal: 0,
      growth: 0,
      nft_list: [],
      timer: null,
      show: false,
      showOrders: false, //控制显示需要解除的订单号
      checkbox: [], //存储解除的订单号
      detail: {
        details: '[]',
      },
      orderlist: [], //持有订单号列表
      addCheckbox: [], //存储添加的订单号
      showAddOrders: false, //控制显示持有订单号
      showPayType: false, //控制显示支付方式
      pay_type: -1, // 服务费支付方式  1token 2teac
    };
  },
  mounted() {
    this.teamine();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    teamine() {
      homeApi.teamine({}).then(res => {
        if (res.code == 200) {
          this.total = res.data.total;
          this.endVal = res.data.total;
          this.growth = res.data.growth;
          this.nft_list = res.data.list;
          this.timer = setInterval(() => {
            this.total = this.endVal;
            this.endVal += this.growth * 7;
          }, 7000);
        } else {
        }
      });
    },
    showChoose(item) {
      this.detail = item;
      this.showOrders = true;
    },
    showAddStoring(item) {
      this.showAddOrders = true;
      this.detail = item;
      this.holdProductList(item.product_id);
    },
    showPayTypeFn(item) {
      this.detail = item;
      this.showPayType = true;
    },
    setRenew() {
      if (this.pay_type == -1) {
        return this.$toast(this.$t('lang470'));
      }
      let _this = this;
      Dialog.confirm({
        title: _this.$t('lang136'),
        message: _this.$t('lang476'),
        confirmButtonText: _this.$t('lang111'),
        cancelButtonText: _this.$t('lang135'),
      })
        .then(() => {
          _this.show = true;

          homeApi.setRenew({ pledge_id: _this.detail.id, pay_type: _this.pay_type }).then(res => {
            if (res.code == 200) {
              _this.show = false;
              _this.showPayType = false;
              _this.detail = {
                details: '[]',
              };
              _this.addCheckbox = [];
              _this.nft_list = [];
              clearInterval(this.timer);
              _this.timer = null;
              _this.teamine();
              Notify({ type: 'success', message: _this.$t('lang152') });
            } else {
              _this.show = false;
              this.$toast(res.msg);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    addPledgeProduct() {
      let _this = this;
      Dialog.confirm({
        title: _this.$t('lang136'),
        message: _this.$t('lang327'),
        confirmButtonText: _this.$t('lang111'),
        cancelButtonText: _this.$t('lang135'),
      })
        .then(() => {
          _this.show = true;

          homeApi.addPledgeProduct({ pledge_id: _this.detail.id, order_id: _this.addCheckbox.join(',') }).then(res => {
            if (res.code == 200) {
              _this.show = false;
              _this.showAddOrders = false;
              _this.detail = {
                details: '[]',
              };
              _this.addCheckbox = [];
              _this.nft_list = [];
              clearInterval(this.timer);
              _this.timer = null;
              _this.teamine();
              Notify({ type: 'success', message: _this.$t('lang152') });
            } else {
              _this.show = false;
              this.$toast(res.msg);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    holdProductList(product_id) {
      homeApi.holdProductList({ product_id }).then(res => {
        if (res.code == 200) {
          this.orderlist = res.data;
        } else {
          this.$toast(res.msg);
        }
      });
    },
    removePledge(item) {
      if (this.detail.type_id == 1 && this.checkbox.length <= 0) {
        return this.$toast(this.$t('lang473'));
      }

      let order_id =
        item.type_id == 1
          ? this.checkbox.join(',')
          : JSON.parse(item.details)
              .map(it => {
                return it.id;
              })
              .join(',');

      console.log(order_id);

      let _this = this;
      Dialog.confirm({
        title: _this.$t('lang136'),
        message: _this.$t('lang335'),
        confirmButtonText: _this.$t('lang111'),
        cancelButtonText: _this.$t('lang135'),
      })
        .then(() => {
          _this.show = true;
          homeApi.removePledge({ pledge_id: item.id, order_id: order_id }).then(res => {
            if (res.code == 200) {
              _this.show = false;
              _this.showOrders = false;
              _this.detail = {
                details: '[]',
              };
              _this.nft_list = [];
              _this.checkbox = [];
              clearInterval(this.timer);
              _this.timer = null;
              _this.teamine();
              Notify({ type: 'success', message: _this.$t('lang152') });
            } else {
              _this.show = false;
              _this.$toast(res.msg);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    collectPledge() {
      this.show = true;
      homeApi.collectPledge({}).then(res => {
        if (res.code == 200) {
          this.show = false;
          clearInterval(this.timer);
          this.timer = null;
          this.teamine();
          Notify({ type: 'success', message: this.$t('lang152') });
        } else {
          this.show = false;
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.2px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  height: 50px;
  z-index: 999;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-sa {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.f-r {
  display: flex;
  align-items: center;
}
.f {
  display: flex;
}
.f-s {
  display: flex;
  align-items: flex-start;
}
.f-c {
  display: flex;
  flex-direction: column;
}
.btn_box {
  padding-top: 14px;
}
.assets {
  height: 100vh;
  padding: 50px 0 0;
  overflow: scroll;
  // background-color: #fafbfc;
  .top {
    color: #000;
    padding-bottom: 16px;
    margin: 0 6px;
  }
  .navbar {
    position: fixed;
    top: 50px;
    z-index: 999;
    width: 100%;
    color: #000;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    span {
      color: #aaaaaa;
      width: 50%;
      font-size: 14px;
      text-align: center;
      line-height: 50px;
    }
  }
  .pd {
    min-height: 100vh;
    padding: 4px;
    margin-top: 54px;
    background-color: #fff;
  }
  .total_box {
    color: #707070;
    padding: 18px;
    margin: 16px 16px 0;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #ffffff;

    .total {
      color: #000;
      font-size: 24px;
      text-align: center;
      font-weight: 600;
      padding-top: 26px;
      .get_btn {
        color: #ffffff;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-weight: normal;
        border: none;
        padding: 0 20px;
        white-space: nowrap;
        border-radius: 30px;
        background-color: #29b286;
      }
    }
    .text {
      color: rgba(#fff, 0.8);
    }
    .buy_box {
      position: absolute;
      bottom: 14px;
      display: flex;
      width: 100%;
      padding: 0 14px;
      align-items: center;
      justify-content: space-between;
    }
    .buy {
      &_btn {
        color: #29b286;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background-color: #ffffff;
        border: none;
        padding: 0 16px;
        white-space: nowrap;
        border-radius: 30px;
      }
    }
  }

  .bare {
    text-align: center;
    font-size: 14px;
    padding: 110px 14px 60px;
    color: #aaa;
  }
  .list {
    border-radius: 20px;
    padding: 0 8px;
    margin-top: 16px;
    background-color: #fff;
    margin: 16px 6px;
    .li {
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      padding: 14px 0;

      .li_left {
        // display: flex;
        // align-items: center;
        .imgbox {
          width: 40px;
          height: 40px;
          border-radius: 15px;
          background-color: #f1f1f1;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 6px;
        }
        .li_img {
          display: block;
          width: 32px;
          height: 32px;
          border-radius: 50%;
        }
        .title {
          color: #29b286;
          font-size: 14px;
          font-weight: bold;
        }
      }
      .box {
        padding-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &_item {
          width: 33%;
          display: flex;
          flex-direction: column;
          .key {
            color: #aaa;
            font-size: 12px;
          }
          .num {
            font-size: 14px;
            color: #000;
            padding-top: 2px;
          }
        }
        .box_item:last-child {
          text-align: right;
        }
      }
    }
  }

  .goods_box {
    // margin: 14px;
    height: 100vh;
    overflow: auto;
    border-radius: 14px;
    .good_icon {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
  .pd1 {
    padding: 16px 14px 14px;
    height: auto;
  }
  .goods_list {
    position: relative;
    color: #000;
    padding: 18px;
    border-radius: 10px;
    margin-bottom: 16px;
    background-color: #fff;

    .tags {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 10px;
      color: #fff;
      padding: 4px 14px;
      z-index: 99;
      background-color: #29b2b0;
      border-radius: 6px 0 6px 0;
    }
    .tags1 {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 10px;
      color: #fff;
      padding: 4px 14px;
      z-index: 99;
      background-color: #f4ab1e;
      border-radius: 6px 0 6px 0;
    }
    .tags3 {
      position: absolute;
      left: 3px;
      top: 3px;
      z-index: 99;
      font-size: 15px;
    }
    .tags2 {
      background-color: #1e8df4;
    }
    &_img {
      width: 60px;
      height: 60px;
      margin: 16px 0;
    }
    .title {
      width: 80%;
      font-weight: 700;
      font-size: 18px;
      overflow: hidden; /* 确保超出容器的文本被裁剪 */
      white-space: nowrap; /* 确保文本在一行内显示 */
      text-overflow: ellipsis; /* 使用省略号表示文本超出 */
    }
    .status {
      font-size: 12px;
      color: #a0a0a0;
    }
    .box {
      width: 100%;
      overflow: auto;
      .item {
        margin-right: 6px;
      }

      .plus {
        width: 60px;
        height: 60px;
        justify-content: center;
        border: 2px solid #5e5e5e;
        border-radius: 10px;
        margin: -12px 0 0 10px;
      }
    }

    .count {
      color: #29b286;
      font-size: 12px;
    }
    .end {
      color: red;
    }
    .rnew {
      color: #29b286;
      font-size: 11px;
      padding: 2px 4px 2px 8px;
      border-radius: 20px;
      border: 1px solid #29b286;
      margin-left: 6px;
    }

    .buy {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      &_btn {
        height: 32px;
        min-width: 96px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        border: none;
        white-space: nowrap;
        border-radius: 30px;
        box-sizing: border-box;
        border: 1px solid #29b286;
        background-color: #29b286;
      }
      .btn1 {
        color: #29b286;
        background-color: #fff;
      }
    }
    .buy1 {
      justify-content: flex-end;
    }
  }
  .orderpopup {
    width: 300px;
    height: fit-content;
    color: #000;
    padding: 16px 30px 0;
    &_title {
      text-align: center;
    }
    &_list {
      margin: 28px 0 10px;
    }
    &_item {
      color: #9b9b9b;
      font-size: 15px;
      padding-bottom: 12px;
      .radio-active {
        color: #000;
      }
    }
    .btn {
      width: 100%;
      color: #21926f;
      letter-spacing: 2px;
      border: 0;
      border-top: 1px solid rgba(#cccccc, 0.8);
      border-radius: 0;
      background-color: #fff;
    }
    .payRadio-box {
      padding: 20px 0;
      .payRadio {
        font-size: 13px;
        padding: 15px 0 8px;
      }
    }
  }

  .nodata {
    font-size: 13px;
    padding: 60px;
    color: #4b4b4b;
    text-align: center;
  }
}
::v-deep .van-cell {
  padding: 10px 0 !important;
}
::v-deep .van-button--danger {
  background-color: #29b286;
  border-color: #29b286;
}
::v-deep .van-address-edit {
  padding: 10px 0;
}
::v-deep .van-ellipsis {
  font-size: 10px !important;
}
::v-deep .van-overlay {
  background-color: rgba(#000, 0.3);
}
::v-deep van-hairline-unset--top-bottom,
::v-deep .van-picker__frame {
  border: 1px solid #fff !important;
}
::v-deep .van-address-edit__buttons {
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}
.wrapper {
  // display: flex;
  // justify-content: center;
  .loading {
    position: absolute;
    left: 46%;
    top: 46%;
  }
}
</style>